const MODULE_NAME = 'okohektarValidator';
export default angular.module(MODULE_NAME, []).directive('okohektarValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, modelCtrl) {
                        modelCtrl.$validators.nonZero = function (modelValue) {
				return parseInt(modelValue) >= 0 && parseInt(modelValue) <= parseInt(scope.$ctrl.formData.hektar);
			};
		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/tamogataskalkulator/validators/okohektarvalidator.js